import classNames from 'classnames'
import * as PropTypes from 'prop-types'
import KeyHandler, { KEYPRESS } from 'react-key-handler'

import contentToFullscreenStyles from './ContentToFullscreen.css'
import { KEYCODES } from '/javascripts/constants/keyCodes'
import { withViewport } from '/react/utils/withViewport'

import {
  IconPlay,
  HeadingHeader,
  HeadingSubHeader,
  ContentBoxButton,
  CustomCursorPlay,
  ToFullscreenAnimation,
  Video,
  Photo
} from '/react/library/'

@withViewport()
export class ContentToFullscreen extends React.PureComponent {
  static propTypes = {
    fillsParent: PropTypes.bool,
    fullscreenVideoSrc: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]).isRequired,
    loopVideoSrc: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    stillImage: PropTypes.object,
    withCustomCursor: PropTypes.bool,
    customPlayButton: PropTypes.string
  }

  state = {
    isFullscreen: false
  }

  containerRef = React.createRef()
  videoLoopRef = React.createRef()
  videoFullscreenRef = React.createRef()

  openFullscreen = () => {
    this.setState({ isFullscreen: true })
    this.pauseVideoLoop()
  }

  closeFullscreen = () => {
    this.playVideoLoop()
    this.setState({
      isFullscreen: false
    })
  }

  playVideoLoop = () => {
    if (!this.videoLoopRef.current) return

    this.videoLoopRef.current.playVideo()
  }

  pauseVideoLoop = () => {
    if (!this.videoLoopRef.current) return

    this.videoLoopRef.current.pauseVideo()
  }

  playVideoFullscreen = () => {
    this.videoFullscreenRef.current.playVideo()
  }

  render () {
    const {
      fillsParent,
      fullscreenVideoSrc,
      loopVideoSrc,
      stillImage,
      viewportIsTabletOrSmaller,
      withCustomCursor,
      customPlayButton
    } = this.props

    const {
      isFullscreen
    } = this.state

    return (
      <div
        className={classNames(
          contentToFullscreenStyles.container,
          { [contentToFullscreenStyles.containerFillsParent]: fillsParent }
        )}
        ref={this.containerRef}
      >
        {loopVideoSrc && (
          <div
            className={classNames(
              contentToFullscreenStyles.loopVideo,
              { [contentToFullscreenStyles.loopVideoFillsParent]: fillsParent }
            )}
            onClick={this.openFullscreen}
          >
            <Video
              fillsParent={fillsParent}
              hasAutoplay
              hasOverlay
              isLooped
              ref={this.videoLoopRef}
              src={loopVideoSrc}
            />

            {(withCustomCursor && !viewportIsTabletOrSmaller) && (
              <div className={contentToFullscreenStyles.customCursor}>
                <CustomCursorPlay onClick={this.openFullscreen} />
              </div>
            )}
          </div>
        )}
        {stillImage && (
          <div className={contentToFullscreenStyles.stillImage}>
            <div className={contentToFullscreenStyles.controlOverlay} onClick={this.openFullscreen}>
              {customPlayButton ? (
                <div className={contentToFullscreenStyles.customButton}>
                  <ContentBoxButton isLight>Play film</ContentBoxButton>
                </div>
              ) : (
                <div className={contentToFullscreenStyles.control}>
                  <IconPlay isLight width={20} height={20} />
                </div>
              )}
            </div>
            <Photo
              backgroundPosition='center top'
              fillsParent
              src={stillImage.src}
              srcSet={stillImage.srcSet}
            />
          </div>
        )}
        {isFullscreen && (
          <React.Fragment>
            <ToFullscreenAnimation
              animationFrameTarget={this.containerRef.current}
              closeFullscreenCallback={this.closeFullscreen}
              fadeContentIn
              onAnimationStart={() => {
                this.pauseVideoLoop()
                this.playVideoFullscreen()
              }}
              content={
                <Video
                  fitsInParent
                  hasAudioToggle
                  hasAutoplay
                  hasControls
                  hasOverlay
                  isLooped
                  ref={this.videoFullscreenRef}
                  src={fullscreenVideoSrc}
                  startsWithSound
                />
              }
            />
            <KeyHandler
              keyEventname={KEYPRESS}
              code={KEYCODES.ESC}
              onKeyHandle={this.closeFullscreen}
            />
          </React.Fragment>
        )}
      </div>
    )
  }
}
